import React, {useEffect, useState} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import BasketsTable from "./BasketsTable";
import {useBasketsUIContext} from "./BasketsUIContext";
import {shallowEqual, useSelector} from "react-redux";
import {useQuery} from "../../../_metronic/_helpers/SearchParams";

export default function BasketsListCmp() {

    const basketContext = useBasketsUIContext();
    const [page, setPage] = useState(1);

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );
    const query = useQuery();

    useEffect(() => {
        setPage(query.get("page") ? query.get("page") : 1);
        basketContext.fetchData(query.get("page") ? query.get("page") : 1, query.get("limit") ? query.get("limit") : '');

    }, [query.get("page"), query.get("limit")]);


    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست سبدها">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                basketContext.fetchData(page)
                            }}>
                            بارگزاری مجدد
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                    {basketContext.data?.data &&
                    <BasketsTable
                        data={basketContext.data}
                        activePage={page}
                    />
                    }

                </CardBody>
            </Card>
        </>
    )
}